/**
 * Pure helpers for the raza event Details "Send WhatsApp" control.
 * Kept separate so visibility / API / error mapping can be unit-tested without jsdom.
 */

import { eventNeedsAnySadarat } from "@/utils/format-raza-event-sadarat-display";

export function shouldShowRazaEventSendWhatsApp(options: {
  needSadaratMale?: unknown;
  needSadaratFemale?: unknown;
  /** Legacy single flag */
  needSadarat?: unknown;
  canEdit: boolean;
}): boolean {
  return (
    eventNeedsAnySadarat({
      needSadaratMale: options.needSadaratMale as boolean | null | undefined,
      needSadaratFemale: options.needSadaratFemale as boolean | null | undefined,
      needSadarat: options.needSadarat as boolean | null | undefined,
    }) && options.canEdit
  );
}

export function isRazaEventSendWhatsAppDisabled(options: {
  mobileNo: unknown;
  sending?: boolean;
}): boolean {
  const mobile = options.mobileNo == null ? "" : String(options.mobileNo).trim();
  return mobile.length === 0 || Boolean(options.sending);
}

export function razaEventSendConfirmationApiLocation(id: string | number): string {
  return `raza-events/${id}/send-confirmation`;
}

export function resolveRazaEventWhatsAppSendError(error: unknown): string {
  const ax = error as { response?: { data?: { message?: unknown } } };
  const m = ax?.response?.data?.message;
  if (typeof m === "string" && m.trim()) {
    return m.trim();
  }
  if (Array.isArray(m)) {
    const joined = m.filter((x): x is string => typeof x === "string").join(", ");
    if (joined.trim()) return joined.trim();
  }
  return "Could not send WhatsApp confirmation";
}
